export default __webpack_public_path__ + "static/media/light-zip.449b6b09.png";